module.exports = __webpack_public_path__ + "static/img/patternBg.f55985a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile_images/patternBg.png
// module id = 8+Y8
// module chunks = 1